<template>
  <fts-design-modal
    class="fts-ai-intention-modal"
    @closed="closed"
    ref="ftsDesignModal"
  >
    <!-- title -->
    <fts-label-group
      slot="title"
      :item="{ name: 'AI Intention', icon: 'fts-icon-magic-lamp' }"
      icon-class="design-modal-header-icon ai-intention-header-icon inistate-text-ai"
      label-class="design-modal-header-name"
      class="design-modal-header-std__title"
    />
    <!-- description -->
    <template #description>
      <span class="design-modal-header-tag">AI</span>
      <span class="design-modal-header-description">
        Artificial intelligence
      </span>
    </template>
    <!-- body -->
    <template #body>
      <fts-form-element
        :form-data="formData"
        :item="{
          fieldName: 'intention',
          icon: 'fts-icon-menu-caret-down'
        }"
        :validator="$v.formData"
        comfort-design
      >
        <template #formElement="{ formData, item, onInput, onBlur }">
          <fts-select
            :form-data="formData"
            :item="item"
            comfort-design
            :options="intentionOptions"
            @input="onInput"
            @search:blur="onBlur"
          >
          </fts-select>
        </template>
      </fts-form-element>

      <fts-form-element
        :form-data="formData"
        :item="{
          fieldName: 'target',
          icon: 'fts-icon-menu-caret-down'
        }"
        :validator="$v.formData"
        comfort-design
      >
        <template #formElement="{ formData, item, onInput, onBlur }">
          <fts-select
            :form-data="formData"
            :item="item"
            comfort-design
            :options="targetOptions"
            @input="onInput"
            @search:blur="onBlur"
          >
            <template #selected-option-container="{ option }">
              <fts-label-group
                :item="option.value"
                information              
                v-if="option.type == 'information'"
              />

              <fts-label-group
                :item="option.value"
                emoji
                v-else
              />
            </template>

            <template #option="{ option }">
              <fts-label-group
                :item="option.value"
                information              
                v-if="option.type == 'information'"
              />

              <fts-label-group
                :item="option.value"
                emoji
                v-else
              />
            </template>
          </fts-select>
        </template>
      </fts-form-element>
      
      <fts-form-element
        :form-data="formData"
        :item="{
          fieldName: 'input',
          type: 16,
          required: true
        }"
        :validator="$v.formData"
        comfort-design
      />
    </template>
    <!-- footer right -->
    <template #footerRight>
      <fts-btn
        color="primary"
        outline
        @click="done"
      >
        <font-awesome-icon :icon="['fas', 'check']" /> Ok
      </fts-btn>
    </template>
  </fts-design-modal>
</template>

<script>
import Vue from 'vue';
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);
import { required } from 'vuelidate/lib/validators';
import { store } from '../store/canvasDesignStore';

import FTSBtn from '../elements/FTSBtn';
import FTSDesignModal from './FTSDesignModal';
import FTSFormElement from '../elements/FTSFormElement';
import FTSLabelGroup from '../elements/FTSLabelGroup';
import FTSSelect from '../elements/FTSSelect';

export default {
  components: {
    "fts-btn": FTSBtn,
    "fts-design-modal": FTSDesignModal,
    "fts-form-element": FTSFormElement,
    "fts-label-group": FTSLabelGroup,
    "fts-select": FTSSelect
  },
  store,
  data: () => ({
    formData: {
      intention: 'core'
    },
    resolve: null,
    intentionOptions: [
      { id: 'core', name: 'Module' },
      { id: 'listing', name: 'Listing' },
      { id: 'sampleData', name: 'Sample Data' }
    ],
    targetOptions: []
  }),
  validations() {
    let formData = {
      input: { required }
    };
    return { formData };
  },
  methods: {
    show({ targetOptions } = {}) {
      return new Promise(async (resolve) => {
        this.resolve = resolve;

        if (targetOptions) {
          this.targetOptions = targetOptions;
        }

        this.$refs.ftsDesignModal.show();
      });
    },
    async done() {
      this.$v.formData.$touch();

      if (this.$v.formData.$invalid) {
        return;
      }

      let result = await this.$store.dispatch("intention", 
        this.formData);

      this.$store.dispatch('loadAIVector', result);

      this.resolve && this.resolve(this.formData);
      this.close();
    },
    close() {
      this.$refs.ftsDesignModal.close();
    },
    closed() {
      this.$v.$reset();
      Object.assign(this.$data, this.$options.data.apply(this));
    }
  }
}
</script>

<style lang="scss">
.fts-ai-intention-modal {
  .ai-intention-header-icon {
    color: var(--fts-ai);
  }
}
</style>